import { Component, Input } from '@angular/core'
import { RegistroService } from '@app/modules/pagamento/folha-residente/service/registro.service'
import { DemonstrativoModel, ProcessamentoOcorrenciaModel, TipoOcorrenciaEnum } from '@shared/models/backend'

@Component({
  selector: 'app-demonstrativo-pagamento-residente',
  templateUrl: './demonstrativo-pagamento-residente.component.html',
  styleUrls: ['./demonstrativo-pagamento-residente.component.scss'],
})
export class DemonstrativoPagamentoResidenteComponent {
  @Input()
  demonstrativo: DemonstrativoModel

  constructor(private registroService: RegistroService) {}

  isRegistroFalta(registro: ProcessamentoOcorrenciaModel) {
    return [
      TipoOcorrenciaEnum.FALTA,
      TipoOcorrenciaEnum.FALTA_MUDANCA_SITUACAO,
      TipoOcorrenciaEnum.SUSPENSO_MUDANCA_SITUACAO,
      TipoOcorrenciaEnum.PERIODO_PRE_MATRICULA,
    ].includes(registro?.ocorrencia?.tipoOcorrencia?.id)
  }

  isRegistroCompensacao(registro: ProcessamentoOcorrenciaModel) {
    return [
      TipoOcorrenciaEnum.COMPENSACAO_FALTA,
      TipoOcorrenciaEnum.COMPENSACAO_CONTESTACAO_PAGAMENTO,
      TipoOcorrenciaEnum.COMPENSACAO_PRORROGACAO_LICENCA_MATERNIDADE,
    ].includes(registro?.ocorrencia?.tipoOcorrencia?.id)
  }

  getRegistroAcertoBolsa() {
    return this?.registros?.find(
      (registro) => registro?.ocorrencia?.tipoOcorrencia?.id === TipoOcorrenciaEnum.ACERTO_BOLSA
    )
  }

  getDescricaoCompletaRegistro(registro: ProcessamentoOcorrenciaModel) {
    return this.registroService.getFullTitle(registro)
  }

  get registros() {
    return this.demonstrativo?.registros?.sort((a, b) => a?.ocorrencia.referencia - b?.ocorrencia?.referencia)
  }

  get faltas() {
    return this.registros?.filter((registro) => this.isRegistroFalta(registro))
  }

  get compensacoes() {
    return this.registros?.filter((registro) => this.isRegistroCompensacao(registro))
  }

  valorDescontosClass(isInss: boolean) {
    const valorDescontos = isInss ? this.demonstrativo?.valorDescontoInss : this.demonstrativo?.valorDescontos
    const red = valorDescontos !== 0 ? ' desconto-text' : ''

    return 'col-12 col-sm text-left text-sm-right' + red
  }

  get valorAditivosClass() {
    const bonusText = this.demonstrativo?.valorAditivos !== 0 ? ' bonus-text' : ''

    return 'col-12 col-sm text-left text-sm-right' + bonusText
  }

  get isValorAditivosZero() {
    return this.demonstrativo?.valorAditivos === 0
  }

  get valorAditivosDesc() {
    const registroAcertoBolsa = this.getRegistroAcertoBolsa()
    if (registroAcertoBolsa) {
      return this.registroService.getFullTitle(registroAcertoBolsa)
    }

    return 'Adicional de faltas compensadas*'
  }

  get faltasText() {
    return !this.getRegistroAcertoBolsa()
      ? '* O valor adicional de compensação de faltas é proporcional ao valor da falta compensada'
      : ''
  }
}
